// extracted by mini-css-extract-plugin
export default {"sectionabout":"TermsAndConditions_sectionabout__bxDcN","title":"TermsAndConditions_title__YSKpB","description":"TermsAndConditions_description__J81m8"};